<template>
<div class="page_info">
  <div class="py-3">
    <img src="static/images/exhibit_info/topbanner-01.jpg" alt="" title="" class="img-fluid">
  </div>

  <div class="container py-5">

    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">EXHIBITION<br>INTRODUCTION</p>
        <p class="topic_cht">展覽介紹</p>
      </div>
    </div>
    <!--展覽介紹-->
    <div class="info_title">
      <h1>掌握國際先驅<br>搶攻億萬佳績</h1>
    </div>

    <div class="info_content">
      <div class="row">
        <div class="col-xl-9 col-lg-8 col-md-12">
          <p>
            2017年車市創十幾年來銷售新高佳績，新車市場相對應推出新款車型，加上汽機車使用率與造車工藝技術逐年提升，
            消費者對於車輛與配備的需求大幅提升，售後維修、零組件換修…等市場空間也隨之擴展，
            擴大車主對於購買後車輛零配件改裝的需求性，彰顯出龐大的車輛改裝商機。
          </p>
          <p>
            根據工研院IEK(Industrial Economics &amp; Knowledge Center，產業經濟與趨勢研究中心)
            統計顯示，2017年我國汽車產業產值約6,109億元，預估2018年將成長1.2%至2.1%，
            而汽車售後市場服務(After Market)，近年來產值持續成長，經濟部統計處於2017年7月發布，
            2016汽車零件業產值高達1921億元，與5年前比較，汽車零件業產值增加6.5%，可見未來市場規模不可小覷。
          </p>
          <p>
            台灣同時身為全球汽車零件主要出口國，加上各界近年來不斷努力下，國內「車輛改裝」
            相關法令已逐步放寬，不論是在國際進出口市場，或是國內改裝市場，都進入到新一輪的發展峰期，
            身為推動台灣改裝車輛技術發展不可或缺的一份子，「2019台北汽機車零配件暨改裝套件展」
            以此希望通過更專業性且具國際標準的展覽平台與廣大的行銷宣傳，
            促進改裝品牌、改裝廠商、改裝配件代理商、經銷商、改裝車俱樂部和改裝車愛好者間的溝通與交流，為台灣車輛改裝事業未來創造出美好的藍海局面。
          </p>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-12">
          <div class="exhibit_intro_icon">
            <div style="display:flex;align-items:center;"><img src="@/assets/icons/exhibit_intro_icon01.png"><div style="display:inline-block;">下載甄展企畫書</div></div>
            <div style="display:flex;align-items:center;"><img src="@/assets/icons/exhibit_intro_icon02.png"><div style="display:inline-block;">裝潢服務<br>平面設計服務</div></div>
            <!--<div><img src="@/assets/icons/exhibit_intro_icon03.png">平面設計服務</div>-->
          </div>
          <router-link :to="{name: 'rules'}" tag="button" class="submit_btn red" style="margin:50px auto;display:block;width:180px;">立 即 線 上 報 名 參 展</router-link>
        </div>
      </div>
      
    </div>

    <!--展覽檔期-->
    <div class="info_schedule py-5">
      <div class="row">
        <div class="col-12 col-lg-4 col-xl-3">
          <div class="page_topic_blcok my-4">
            <div class="topic_border">
              <p class="topic_eng">EXHIBITION<br>CALENDAR</p>
              <p class="topic_cht">展覽檔期表</p>
            </div>
          </div>
        </div>
        <div class="season_block px-5 col-12 col-lg-8 col-xl-9">
          <div class="item_content px-4">
            <h2>春夏季</h2>
            <ul>
              <li>03/01 - 03/04 台中 大台中國際會議中心</li>
              <li>04/05 - 04/08 台北 台北世貿一館</li>
              <li>06/08 - 06/11 高雄 高雄展覽館</li>
              <li>06/15 - 06/18 台北 台北世貿三館</li>
           </ul>
          </div>
          <hr>
          <div class="item_content px-4">
            <h2>秋冬季</h2>
            <ul>
              <li>03/01 - 03/04 台中 大台中國際會議中心</li>
              <li>04/05 - 04/08 台北 台北世貿一館</li>
              <li>06/08 - 06/11 高雄 高雄展覽館</li>
              <li>06/15 - 06/18 台北 台北世貿三館</li>
           </ul>
          </div>
        </div>
      </div>
    </div>

    <!--展覽統計-->
    <div>
      <div class="row justify-content-end align-items-baseline">
        <div class="px-4">
          <h2 style="font-size: 2.5rem;">客層分析及人潮統計</h2>
        </div>

        <div>
          <div class="page_topic_blcok my-4">
            <div class="topic_border" style="border-left: 1px solid #d6d6d6;border-right:none;">
              <p class="topic_eng">BENEFITS OF<br>PARTICPATION</p>
              <p class="topic_cht">參展效益</p>
            </div>
          </div>
        </div>
      </div>
      <div class="benefit_chart_block">
        <div class="row text-center">
          <!-- 圓餅圖 -->
          <div class="col-xl-8 col-lg-6 col-md-12">
            <div id="legendPlaceholder"></div>
            <div id="chart1" class="flotcontainer"></div>
            <div id="chart2" class="flotcontainer"></div>
          </div>
          <!-- 直條圖 -->
          <div class="col-xl-4 col-lg-6 col-md-12">
            <div id="line_chart1" class="flotcontainer_line">
              <div>
                <p>10/06(五)</p>
                <p>53,160</p>
              </div>
              <div>
                <p>10/07(六)</p>
                <p>73,410</p>
              </div>
              <div>
                <p>10/08(日)</p>
                <p>60,755</p>
              </div>
              <div>
                <p>10/09(一)</p>
                <p>65,818</p>
              </div>
            </div>
            <p style="height:100px;"></p>
            <div id="line_chart2" class="flotcontainer_line">
              <div>
                <p>3/31(四)</p>
                <p>89,183</p>
              </div>
              <div>
                <p>4/01(五)</p>
                <p>98,612</p>
              </div>
              <div>
                <p>4/02(六)</p>
                <p>101,227</p>
              </div>
              <div>
                <p>4/03(日)</p>
                <p>96,468</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--精彩回顧-->
    <div class="info_schedule py-5">
      <div class="row">
        <div class="col-12 col-lg-4 col-xl-3">
          <div class="page_topic_blcok my-4">
            <div class="topic_border">
              <p class="topic_eng">EXHIBITION<br>REVIEW</p>
              <p class="topic_cht">精彩回顧</p>
            </div>
          </div>
        </div>
      </div>
      <div class="exhibition_review_block">
        <div class="review_block_left">
          <div>
            <a href="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/kBJet5Vfsugt.jpg" class="review_img_adjust" data-fancybox="review_img" style="flex:1;"><img src="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/kBJet5Vfsugt.jpg" /></a>
            <a href="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/tVc9QYCigsJJ.jpg" class="review_img_adjust" data-fancybox="review_img" style="flex:1;"><img src="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/tVc9QYCigsJJ.jpg" /></a>
          </div>
          <div>
            <a href="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/BuZBun8XjxZZ.jpg" class="review_img_adjust" data-fancybox="review_img" style="flex:1;"><img src="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/BuZBun8XjxZZ.jpg" /></a>
            <a href="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/zY79pm5cATCz.jpg" class="review_img_adjust" data-fancybox="review_img" style="flex:2;"><img src="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/zY79pm5cATCz.jpg" /></a>
          </div>
        </div>
        <div class="review_block_right">
          <a href="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/ArLEDeviu4YF.jpg" class="review_img_adjust" data-fancybox="review_img" style="flex:2;"><img src="https://dykt84bvm7etr.cloudfront.net/uploadfiles/738/portal/item/ArLEDeviu4YF.jpg" /></a>
          <a href="https://dykt84bvm7etr.cloudfront.net/uploadfiles/735/portal/item/zr77t7kNwMQZ.jpg" class="review_img_adjust" data-fancybox="review_img" style="flex:1;"><img src="https://dykt84bvm7etr.cloudfront.net/uploadfiles/735/portal/item/zr77t7kNwMQZ.jpg" /></a>
        </div>
      </div>
    </div>
    

  </div>
</div>
</template>

<script>
export default {
  data () {
    return{};
  },
  mounted () {
    // 圖表設定
$(function(){
  //pie內容資料
  var data_1 = [{           
      label: "店家",
      data: 70,
      color: '#ff8229'
    },
    {
      label: "民眾",
      data: 25,
      color: '#ffcd56'
    },
    {
      label: "其他",
      data: 5,
      color: '#ffeb5f'
    }
  ];
  var data_2 = [{           
      label: "北區－4場",
      data: 62.14,
      color: '#00abec'
    },
    {
      label: "中區－2場",
      data: 14.44,
      color: '#5cd1fd'
    },
    {
      label: "南區－3場",
      data: 23.42,
      color: '#47e8f9'
    }
  ];
  //pie顯示設定
  var options_1 = {
      series: {
        pie: {
          show: true,
          radius: 0.8,       //pie半徑比例 0 - 1
          innerRadius: 0,  //內孔半徑比例 0 - 1
          startAngle: 0.1,   //初始角度(pie旋轉) 0 - 2
          offset: {          //pie位置設定
            top: 0,
            left: 'auto'
          },
          stroke: {          //pie各餅border顏色、寬度(建議使用#ffffff六碼色號較不易出錯)
            color: '#888888',
            width: 0
          },
          label: {            //標籤設定
            show: true,       //標籤開關 true, false, auto(隨legend調整)
            radius: 0.8,      //標籤位置 0 - 1
            formatter: function (label, series) {
              return `<div class="pie_label">${label}<br/>${Math.round(series.percent)}%</div>`;
            }, //決定標籤該如何格式化(.pieLabel為他的class) -->推薦CSS自行定義
            background: {     //標籤背景
              color: 'null',    // null則自動帶入pie的顏色
              opacity: 0.8
            }
          }
        }
      },
      legend: {
        show: false
      },
      grid: {
        hoverable: true
      }
    };
  var options_2 = {
      series: {
        pie: {
          show: true,
          radius: 0.8,       //pie半徑比例 0 - 1
          innerRadius: 0,  //內孔半徑比例 0 - 1
          startAngle: 0.2585,   //初始角度(pie旋轉) 0 - 2
          offset: {          //pie位置設定
            top: 0,
            left: 'auto'
          },
          stroke: {          //pie各餅border顏色、寬度(建議使用#ffffff六碼色號較不易出錯)
            color: '#888888',
            width: 0
          },
          label: {            //標籤設定
            show: true,       //標籤開關 true, false, auto(隨legend調整)
            radius: 0.8,      //標籤位置 0 - 1
            formatter: function (label, series) {
              let num = Math.round(series.percent/100 * 1522779).toString();
              num = num.replace(/([0-9]{3}$)/, ',$1');
              return `<div class="pie_label">${label}<br/>${num}</div>`;
            }, //決定標籤該如何格式化(.pieLabel為他的class) -->推薦CSS自行定義
            background: {     //標籤背景
              color: 'null',    // null則自動帶入pie的顏色
              opacity: 0.8
            }
          }
        }
      },
      legend: {
        show: false
      },
      grid: {
        hoverable: true
      }
    };
  // PIE資料帶入區塊
  $.plot($("#chart1"), data_1, options_1);
  $.plot($("#chart2"), data_2, options_2);
  });


  // review_img fancybox
  $(".review_img_adjust").fancybox({
    smallBtn: true,   //取消按鈕
		protect: true,   //禁止右鍵
    loop: true,     //輪迴
    toolbar: true,    //右上功能列
    animationEffect: "zoom", // "fade","zoom-in-out",false
    animationDuration: 300,
    transitionEffect: "slide", // "fade","circular","tube","zomm-in-out","rotate"
    transitionDuration: 366,
    baseClass: "",  // 自定義基底CSS Class
    slideClass: "img_slide"  // 自定義滑動元素CSS Class
  });



  } // JQuery END
} // mounted END

</script>
<style>
/**page_topic**/
.page_topic_blcok { 
  display:inline-block; 
  text-align: right;
}
.page_topic_blcok .topic_border { 
  padding: 0px 1rem 1px 0;
  border-right:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1.1;
}
.page_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.5;
  margin:0;
}
.page_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  line-height:1.5;
  letter-spacing:9px;
  margin-right:-9px; 
}
/* btn */
.submit_btn{
  outline:none;
  border:0;
  margin:0;
  padding:0;
  box-sizing: border-box;
}
.submit_btn.red{
  background: rgba(255, 0, 51, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}
.submit_btn.blue{
  background: rgba(25, 158, 216, 1);
  color:white;
  width:140px;
  height:40px;
  border:1px solid rgba(255, 255, 255, 1);
  border-radius: 5px;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);
}

/**info_desc**/
.info_title {
  padding: 2% 0;
  letter-spacing:0.5rem;
  margin-left: 8rem;
  text-indent : -8em ;
}
.info_title h1 {
  line-height: 3.5rem;
}
.info_content p{
  font-size: 1.2rem;
  line-height: 2;
  text-align: justify;
}

/* exhibit_intro_icon */
.exhibit_intro_icon {
  margin-top:150px;
}
.exhibit_intro_icon > div {
  color:#f1884b;
  font-size:21px;
  font-weight:bold;
  letter-spacing:3.5px;
  margin-left:20px;
  margin-top:40px;
}
.exhibit_intro_icon > div img {
  margin-right:8px;
}

@media (max-width:992px){
  .exhibit_intro_icon {
    display:flex;
    justify-content:space-around;
    flex-wrap:wrap;
    margin-top:0;
  }
  .exhibit_intro_icon > div {
    color:#f1884b;
    font-size:21px;
    font-weight:bold;
    letter-spacing:3.5px;
  }
}
@media (max-width:768px){
  .exhibit_intro_icon > div img {
    width:31px;
  }
  .exhibit_intro_icon > div {
    font-size:16px;
  }
}

/**info_schedule**/
/*.info_schedule {}

.info_schedule .season_block {}*/
.info_schedule .season_block hr { margin: 3% 0;}
.info_schedule .season_block .item_content:first-child { padding-top: 6.8rem; }
.info_schedule .season_block .item_content h2 { font-size: 2.5rem; line-height: 2}
.info_schedule .season_block .item_content ul {line-height: 2; font-size: 1.2rem;}

@media (max-width: 992px){
  .info_schedule .season_block .item_content:first-child { padding-top:1rem; }
}

/* 圖表區塊 */
.benefit_chart_block .row>div:first-child {
  margin-top:200px;
}

@media (max-width:1200px){
  .benefit_chart_block .row>div:first-child {
    margin-top:0;
  }
}


/* Pie Chart */
.flotcontainer {
  display:inline-block;
  width: 360px;
  height: 300px;
  transition:all 0.5s;
}
.flotcontainer:hover {
  transform:scale(1.05);
}
.pie_label {
  font-size:16px;
  text-align:center;
  padding:5px;
  color:white;
  font-weight:bold;
  opacity:1;
  background:rgba(0, 0, 0, 0.7);
  border:1px solid #cecece;
  border-radius:5px;
  box-shadow:1px 2px 2px #6c757d;
  transition: all 0.5s;
}
.pie_label:hover {
  font-size:18px;
  color:black;
  box-shadow:2px 4px 5px #6c757d;
  background:rgba(255, 255, 255, 1);
}



/* Line Chart */
.flotcontainer_line {
  display:inline-flex;
  justify-content:space-evenly;
  align-items:flex-end;
  position:relative;
  width:350px;
  height:200px;
  border-width:0 0 2px 2px;
  border-style:solid;
  border-color:#cdcdcd;
}

/* bar 共通設定 */
.flotcontainer_line>div {
  position:relative;
  width:25px;
}
.flotcontainer_line>div:hover {
  opacity:0.8;
}
.flotcontainer_line>div:first-child {
  background:#183e65;
}
.flotcontainer_line>div:nth-child(2) {
  background:#b7b7b7;
}
.flotcontainer_line>div:nth-child(3) {
  background:#fac03b;
}
.flotcontainer_line>div:nth-child(4) {
  background:#ee7530;
}
.flotcontainer_line>div>p:first-child {
  position:absolute;
  top:-30px;
  left:-17px;
  font-size:14px;
}
.flotcontainer_line>div>p:nth-child(2) {
  position:absolute;
  bottom:-40px;
  left:-10px;
  font-size:14px;
}


/* line_chart1 設定 */
#line_chart1 {
  --chart1_bar01: 53160px;
  --chart1_bar02: 73412px;
  --chart1_bar03: 60755px;
  --chart1_bar04: 65818px;
}
#line_chart1::before {
  content:'春夏季';
  position:absolute;
  font-size:23px;
  font-weight:bold;
  left:-10%;
  bottom:10px;
  width:20px;
  line-height:1.3;
}
#line_chart1>div:first-child {
  height:calc(200*var(--chart1_bar01)/100000);
}
#line_chart1>div:nth-child(2) {
  height:calc(200*var(--chart1_bar02)/100000);
}
#line_chart1>div:nth-child(3) {
  height:calc(200*var(--chart1_bar03)/100000);
}
#line_chart1>div:nth-child(4) {
  height:calc(200*var(--chart1_bar04)/100000);
}

/* line_chart2 設定 */
#line_chart2 {
  --chart2_bar01: 89183px;
  --chart2_bar02: 98612px;
  --chart2_bar03: 101227px;
  --chart2_bar04: 96468px;
}
#line_chart2::before {
  content:'秋冬季';
  position:absolute;
  font-size:23px;
  font-weight:bold;
  left:-10%;
  bottom:10px;
  width:20px;
  line-height:1.3;
}
#line_chart2>div:first-child {
  height:calc(200*var(--chart2_bar01)/100000);
}
#line_chart2>div:nth-child(2) {
  height:calc(200*var(--chart2_bar02)/100000);
}
#line_chart2>div:nth-child(3) {
  height:calc(200*var(--chart2_bar03)/100000);
}
#line_chart2>div:nth-child(4) {
  height:calc(200*var(--chart2_bar04)/100000);
}

/* 精彩回顧 */
.exhibition_review_block {
  display:flex;
  flex-flow:row wrap;
  width:100%;
  height:360px;
  margin:30px auto;
  overflow:hidden;
}
.review_block_left {
  display:flex;
  flex-flow:column wrap;
  width:51%;
  height:100%;
}
.review_block_right {
  display:flex;
  flex-flow:row wrap;
  width:49%;
  height:100%;
}

@media (max-width:768px){
  .exhibition_review_block {
    height:auto;
  }
  .review_block_left {
    flex-flow:column wrap;
    width:100%;
    height:720px;
  }
  .review_block_right {
    flex-flow:column wrap;
    width:100%;
    height:360px;
  }
}

/* 左欄 */
.review_block_left>div  {
  width:100%;
  height:50%;
  display:flex;
  flex-flow:row wrap;
}

.review_block_left .review_img_adjust {
  display:flex;
  justify-content:center;
  overflow:hidden;
  box-sizing:border-box;
  margin:3px;
}

@media (max-width:768px){
  .review_block_left>div {
    flex-flow:column wrap;
  }
}

/* 右欄 */
.review_block_right .review_img_adjust {
  display:flex;
  justify-content:center;
  overflow:hidden;
  width:50%;
  height:98.2%;
  box-sizing:border-box;
  margin:3px;
}


.exhibition_review_block img {
  width:auto;
  height:100%;
  transform:scale(1);
  transition:all 0.5s;
}
.exhibition_review_block img:hover {
  transform:scale(1.1);
}


.img_slide img {
  border:10px solid white;
  border-radius:5px;
}

@media (max-width:992px){
  .review_block_right {
    flex-flow:column wrap;
  }
  .review_block_right .review_img_adjust {
    width:100%;
    flex:1 !important;
  }
  .review_block_right .review_img_adjust img {
    width:100%;
    height:auto;
  }
}

@media (max-width:768px){
  .review_img_adjust {
    flex:1 !important;
    width:100%;
    align-items:center;
  }
  .exhibition_review_block img {
    width:100%;
    height:auto;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/pages/exhibit_info.vue